define( function() {
	return ( /<([\w:-]+)/ );
} );



//////////////////
// WEBPACK FOOTER
// /var/www/html/themes/base/node_modules/jquery/src/manipulation/var/rtagName.js
// module id = 55
// module chunks = 8